import * as React from 'react'
import Trash from '../../../../../../../assets/icons_new/DeleteColor.svg'
import AssignToDiffrentDriverColor from '../../../../../../../assets/icons_new/AssignToDiffrentDriverColor.svg'
import TableActionBar from '@/modules/drivers/shared/tableItems/TableActionBar'
import { TableActionButtonInterface } from '@/modules/drivers/types'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import { useTable } from '@/modules/drivers/context/TableContext'
import AssignCardToDriverModal from '@/modules/drivers/modals/driverCards/AssignCardToDriverModal'

const DriverCardsActions = ({
  companyId,
  driverId,
}: {
  companyId: string
  driverId: number
}) => {
  const { t } = useLocalize()
  const { selectedGroup, resetAll } = useTable()
  const [isAssignModalOpen, setIsAssignModalOpen] = React.useState(false)
  const selectedCardId = Number(selectedGroup?.ids?.[0])

  const actions: TableActionButtonInterface[] = [
    {
      icon: AssignToDiffrentDriverColor,
      action: () => setIsAssignModalOpen(true),
      tooltip: t('driverModule.assign-to-another-driver'),
    },
    {
      icon: Trash,
      action: () => console.log(),
      tooltip: t('common.delete'),
    },
  ]
  return (
    <>
      <TableActionBar actions={actions} />
      {isAssignModalOpen && !!selectedCardId && (
        <AssignCardToDriverModal
          companyId={companyId}
          driverId={driverId}
          driverCardId={selectedCardId}
          close={() => setIsAssignModalOpen(false)}
          onAssigned={resetAll}
        />
      )}
    </>
  )
}

export default DriverCardsActions
